import React from 'react';
import { motion } from 'framer-motion';

const NauticalBlueprintBackground: React.FC = () => {
  const draw = {
    hidden: { pathLength: 0, opacity: 0 },
    visible: {
      pathLength: 1,
      opacity: 1,
      transition: {
        pathLength: { type: "spring", duration: 2.5, bounce: 0 },
        opacity: { duration: 0.01 }
      }
    }
  };

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <motion.svg
        width="100%"
        height="100%"
        viewBox="0 0 1000 1000"
        initial="hidden"
        animate="visible"
        className="absolute inset-0"
        style={{
          transform: 'rotate(-45deg) scale(1.5)', // Diagonal positioning and scale for subtlety
          transformOrigin: 'center center',
          filter: 'drop-shadow(0 0 5px rgba(var(--gold-rgb), 0.1))',
        }}
      >
        {/* Compass Rose */}
        <motion.circle
          cx="500"
          cy="500"
          r="200"
          stroke="hsl(var(--gold) / 0.1)" // Very subtle gold
          strokeWidth="2"
          fill="none"
          variants={draw}
          custom={1}
        />
        <motion.path
          d="M500,300 V700 M300,500 H700" // North-South, East-West lines
          stroke="hsl(var(--gold) / 0.1)"
          strokeWidth="1.5"
          fill="none"
          variants={draw}
          custom={2}
        />
        <motion.path
          d="M358.5,358.5 L641.5,641.5 M358.5,641.5 L641.5,358.5" // Diagonal lines
          stroke="hsl(var(--gold) / 0.1)"
          strokeWidth="1"
          fill="none"
          variants={draw}
          custom={3}
        />
        {/* North pointer */}
        <motion.path
          d="M500,280 L520,320 L480,320 Z"
          fill="hsl(var(--gold) / 0.15)" // Slightly more visible
          stroke="hsl(var(--gold) / 0.1)"
          strokeWidth="0.5"
          variants={draw}
          custom={4}
        />
         {/* Small decorative circles */}
         <motion.circle
          cx="500"
          cy="300"
          r="5"
          stroke="hsl(var(--gold) / 0.1)"
          strokeWidth="0.5"
          fill="hsl(var(--gold) / 0.05)"
          variants={draw}
          custom={5}
        />
        <motion.circle
          cx="500"
          cy="700"
          r="5"
          stroke="hsl(var(--gold) / 0.1)"
          strokeWidth="0.5"
          fill="hsl(var(--gold) / 0.05)"
          variants={draw}
          custom={6}
        />
        <motion.circle
          cx="300"
          cy="500"
          r="5"
          stroke="hsl(var(--gold) / 0.1)"
          strokeWidth="0.5"
          fill="hsl(var(--gold) / 0.05)"
          variants={draw}
          custom={7}
        />
        <motion.circle
          cx="700"
          cy="500"
          r="5"
          stroke="hsl(var(--gold) / 0.1)"
          strokeWidth="0.5"
          fill="hsl(var(--gold) / 0.05)"
          variants={draw}
          custom={8}
        />

        {/* Larger semi-transparent circle as general blueprint element */}
        <motion.circle
          cx="500"
          cy="500"
          r="400"
          stroke="hsl(var(--gold) / 0.05)"
          strokeWidth="1"
          fill="none"
          variants={draw}
          custom={9}
        />

      </motion.svg>
    </div>
  );
};

export default NauticalBlueprintBackground;